"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.googleMapURL = exports.api = exports.default = void 0;
var cfg = {
  api: {
    baseUrl: '/api',
    userApiUrlTemplate: function userApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/users");
    },
    userSingleApiUrlTemplate: function userSingleApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/users/").concat(id);
    },
    createFarmFromUserTemplate: function createFarmFromUserTemplate(lang, id) {
      return "/api/".concat(lang, "/users/").concat(id, "/farm");
    },
    farmApiUrlTemplate: function farmApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/farms");
    },
    farmSingleApiUrlTemplate: function farmSingleApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id);
    },
    cantonApiUrlTemplate: function cantonApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/cantons");
    },
    animalApiUrlTemplate: function animalApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/animals");
    },
    zoneApiUrlTemplate: function zoneApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/zones");
    },
    salutationApiUrlTemplate: function salutationApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/salutations");
    },
    correspondenceLanguageApiUrlTemplate: function correspondenceLanguageApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/correspondence-languages");
    },
    regionApiUrlTemplate: function regionApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/regions");
    },
    culturesApiUrlTemplate: function culturesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/cultures");
    },
    productiontypesApiUrlTemplate: function productiontypesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/productiontypes");
    },
    operatingmodesApiUrlTemplate: function operatingmodesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/operatingmodes");
    },
    productionlabelsApiUrlTemplate: function productionlabelsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/productionlabels");
    },
    productionlabelsAddImageApiUrlTemplate: function productionlabelsAddImageApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/productionlabels/").concat(id, "/images");
    },
    productionlabelsRemoveImageApiUrlTemplate: function productionlabelsRemoveImageApiUrlTemplate(lang, id, imageId) {
      return "/api/".concat(lang, "/productionlabels/").concat(id, "/images/").concat(imageId);
    },
    programsApiUrlTemplate: function programsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/programs");
    },
    programsAddImageApiUrlTemplate: function programsAddImageApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/programs/").concat(id, "/images");
    },
    programsRemoveImageApiUrlTemplate: function programsRemoveImageApiUrlTemplate(lang, id, imageId) {
      return "/api/".concat(lang, "/programs/").concat(id, "/images/").concat(imageId);
    },
    userEmailVerifiedApiUrlTemplate: function userEmailVerifiedApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/users/").concat(id, "/email-verified");
    },
    userFromFarmApiUrlTemplate: function userFromFarmApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/user");
    },
    brunchApiUrlTemplate: function brunchApiUrlTemplate(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/brunches");
    },
    brunchResetApiUrlTemplate: function brunchResetApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/brunches/reset");
    },
    placedetailsApiUrlTemplate: function placedetailsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/placedetails");
    },
    schubApiUrlTemplate: function schubApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/schub");
    },
    schubForeignOrganisatorByIdApiTemplate: function schubForeignOrganisatorByIdApiTemplate(lang, id) {
      return "/api/".concat(lang, "/schub-foreignorganisator/").concat(id);
    },
    schubForeignOrganisatorApiTemplate: function schubForeignOrganisatorApiTemplate(lang) {
      return "/api/".concat(lang, "/schub-foreignorganisator");
    },
    infrastructuresApiUrlTemplate: function infrastructuresApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/infrastructures");
    },
    targetGroupsApiUrlTemplate: function targetGroupsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/target-groups");
    },
    themesApiUrlTemplate: function themesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/themes");
    },
    lockpfostenAllApiUrlTemplate: function lockpfostenAllApiUrlTemplate(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/lockpfostenAll");
    },
    lockpfostenApiUrlTemplate: function lockpfostenApiUrlTemplate(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/lockpfosten");
    },
    lockpfostenResetApiUrlTemplate: function lockpfostenResetApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/lockpfosten/reset");
    },
    pfostenApiUrlTemplate: function pfostenApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/pfostensAll");
    },
    membershipFeeFromFarmApiUrlTemplate: function membershipFeeFromFarmApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/membership-fee");
    },
    // project toh endpoints
    tohFromFarmApiUrl: function tohFromFarmApiUrl(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/toh");
    },
    tohResetApiUrlTemplate: function tohResetApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/toh/reset");
    },
    // project stallvisite endpoints
    stallvisiteApiUrlTemplate: function stallvisiteApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/stallvisite");
    },
    categoriesApiUrlTemplate: function categoriesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/categories");
    },
    subcategoriesApiUrlTemplate: function subcategoriesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/subcategories");
    },
    stallvisiteFromFarmApiUrl: function stallvisiteFromFarmApiUrl(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/stallvisite");
    },
    categoriesWithSubcategoriesApiUrlTemplate: function categoriesWithSubcategoriesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/categories/subcategories");
    },
    // project vomhof endpoints
    vomhofFromFarmApiUrl: function vomhofFromFarmApiUrl(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/vomhof");
    },
    manufacturetypeApiUrlTemplate: function manufacturetypeApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/manufacturetypes");
    },
    metarubricApiUrlTemplate: function metarubricApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/metarubrics");
    },
    offerCategoryApiUrlTemplate: function offerCategoryApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/offer-categories");
    },
    productApiUrlTemplate: function productApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/products");
    },
    rubricApiUrlTemplate: function rubricApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/rubrics");
    },
    vacationCategorieApiUrlTemplate: function vacationCategorieApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/vacation-categories");
    },
    availabilityApiUrlTemplate: function availabilityApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/months");
    },
    paymentMehtodApiUrlTemplate: function paymentMehtodApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/payment-methods");
    },
    vomhofAddOffer: function vomhofAddOffer(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer");
    },
    vomhofUpdateProject: function vomhofUpdateProject(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof");
    },
    vomhofUpdateOffer: function vomhofUpdateOffer(lang, farmId, offerId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId);
    },
    vomhofOfferRemoveImage: function vomhofOfferRemoveImage(lang, farmId, offerId, imageId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId, "/images/").concat(imageId);
    },
    vomhofOfferRemoveFile: function vomhofOfferRemoveFile(lang, farmId, offerId, fileId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId, "/files/").concat(fileId);
    },
    vomhofOfferAddImage: function vomhofOfferAddImage(lang, farmId, offerId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId, "/images");
    },
    vomhofOfferAddFile: function vomhofOfferAddFile(lang, farmId, offerId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId, "/files");
    },
    vomhofOfferUpdateFileSorting: function vomhofOfferUpdateFileSorting(lang, farmId, offerId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/offer/").concat(offerId, "/images/update-sort");
    },
    outletCategoriesAPITemplate: function outletCategoriesAPITemplate(lang) {
      return "/api/".concat(lang, "/outlet-categories");
    },
    vomhofAddVacation: function vomhofAddVacation(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/vacation");
    },
    vomhofUpdateVacation: function vomhofUpdateVacation(lang, farmId, vacationId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/vacation/").concat(vacationId);
    },
    vomhofAddOutlet: function vomhofAddOutlet(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/outlet");
    },
    vomhofUpdateOutlet: function vomhofUpdateOutlet(lang, farmId, outletId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/outlet/").concat(outletId);
    },
    vomhofDeleteOtherOutlet: function vomhofDeleteOtherOutlet(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/vomhof/other-outlets");
    },
    vomhofApiUrlTemplate: function vomhofApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/vomhof");
    },
    schubsApiUrlTemplate: function schubsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/schubs");
    },
    brunchesApiUrlTemplate: function brunchesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/brunches");
    },
    lockpfostensApiUrlTemplate: function lockpfostensApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/lockpfosten");
    },
    projectsRegistrations: function projectsRegistrations(lang) {
      return "/api/".concat(lang, "/project-registrations");
    },
    farmRegistrations: function farmRegistrations(lang) {
      return "/api/".concat(lang, "/farm-registrations");
    },
    userRegistrations: function userRegistrations(lang) {
      return "/api/".concat(lang, "/user-registrations");
    },
    farmReleaseStatusUrl: function farmReleaseStatusUrl(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/release-status");
    },
    updateFarmReleaseStatusUrl: function updateFarmReleaseStatusUrl(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/release-status");
    },
    checkProjectStatusUrl: function checkProjectStatusUrl(lang, farmId, projectKey) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/project-release-status/").concat(projectKey, "/check");
    },
    releaseProjectStatusUrl: function releaseProjectStatusUrl(lang, farmId, projectKey) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/project-release-status/").concat(projectKey, "/release");
    },
    projectReleaseStatusByFarmUrl: function projectReleaseStatusByFarmUrl(lang, farmId, projectKey) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/project-release-status/").concat(projectKey);
    },
    sponsoringQuestions: function sponsoringQuestions(lang) {
      return "/api/".concat(lang, "/sponsoring-question");
    },
    brunchForeignOrganisatorsApiTemplate: function brunchForeignOrganisatorsApiTemplate(lang) {
      return "/api/".concat(lang, "/brunch-foreignorganisator");
    },
    brunchForeignOrganisatorApiTemplate: function brunchForeignOrganisatorApiTemplate(lang, id) {
      return "/api/".concat(lang, "/brunch-foreignorganisator/").concat(id);
    },
    farmApiAddImage: function farmApiAddImage(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/images");
    },
    farmApiAddDocument: function farmApiAddDocument(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/documents");
    },
    farmApiRemoveImage: function farmApiRemoveImage(lang, farmId, imageId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/images/").concat(imageId);
    },
    farmApiRemoveDocument: function farmApiRemoveDocument(lang, farmId, documentId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/documents/").concat(documentId);
    },
    farmApiMainImage: function farmApiMainImage(lang, farmId, imageId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/main-image/").concat(imageId);
    },
    farmApiLogo: function farmApiLogo(lang, farmId, imageId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/logo/").concat(imageId);
    },
    farmApiUpdateSorting: function farmApiUpdateSorting(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/images/update-sort");
    },
    brunchApiAddImage: function brunchApiAddImage(lang, id, brunchId) {
      return "/api/".concat(lang, "/farms/").concat(id, "/brunches/").concat(brunchId, "/images");
    },
    brunchApiAddDocument: function brunchApiAddDocument(lang, id, brunchId) {
      return "/api/".concat(lang, "/farms/").concat(id, "/brunches/").concat(brunchId, "/documents");
    },
    brunchApiRemoveImage: function brunchApiRemoveImage(lang, id, brunchId, imageId) {
      return "/api/".concat(lang, "/farms/").concat(id, "/brunches/").concat(brunchId, "/images/").concat(imageId);
    },
    brunchApiRemoveFile: function brunchApiRemoveFile(lang, id, brunchId, documentId, type) {
      return "/api/".concat(lang, "/farms/").concat(id, "/brunches/").concat(brunchId, "/").concat(type, "/").concat(documentId);
    },
    acquisitiontypesApiUrlTemplate: function acquisitiontypesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/acquisitiontypes");
    },
    updateUserName: function updateUserName(lang, id) {
      return "/api/".concat(lang, "/users/").concat(id, "/username");
    },
    projectLock: function projectLock(project) {
      return "/api/project-lock/".concat(project);
    },
    // Get project interests by user id
    projectInterestsByUserId: function projectInterestsByUserId(lang, id) {
      return "/api/".concat(lang || 'de', "/users/").concat(id);
    },
    //message endpoints
    messagesApiUrlTemplate: function messagesApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/message");
    },
    messageReadApiUrlTemplate: function messageReadApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/message/").concat(id, "/read");
    },
    messageDeleteApiUrlTemplate: function messageDeleteApiUrlTemplate(lang, id) {
      return "/api/".concat(lang, "/message/").concat(id);
    },
    dashboardSettingsApiUrlTemplate: function dashboardSettingsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/dashboard/settings");
    },
    dashboardSettingsUpdateApiUrlTemplate: function dashboardSettingsUpdateApiUrlTemplate(lang, key, value) {
      return "/api/".concat(lang, "/dashboard/settings/").concat(key, "/").concat(value);
    },
    allProjects: function allProjects(lang) {
      return "/api/".concat(lang, "/projects");
    },
    // project lgw endpoints
    lgwFromFarmApiUrl: function lgwFromFarmApiUrl(lang, id) {
      return "/api/".concat(lang, "/farms/").concat(id, "/lgw");
    },
    lgwProductApiUrlTemplate: function lgwProductApiUrlTemplate(lang) {
      return "/api/".concat(lang || 'de', "/lgwproducts");
    },
    lgwApiUrlTemplate: function lgwApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/lgw");
    },
    lgwUpdateProject: function lgwUpdateProject(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/lgw");
    },
    lgwPublishApiUrlTemplate: function lgwPublishApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/lgw/publish");
    },
    lgwOffer: function lgwOffer(lang) {
      return "/api/".concat(lang, "/lgw/offer");
    },
    lgwOfferById: function lgwOfferById(lang, offerId) {
      return "/api/".concat(lang, "/lgw/offer/").concat(offerId);
    },
    lgwAddOffer: function lgwAddOffer(lang, farmId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/lgw/offer");
    },
    lgwUpdateOffer: function lgwUpdateOffer(lang, farmId, offerId) {
      return "/api/".concat(lang, "/farms/").concat(farmId, "/lgw/offer/").concat(offerId);
    }
  },
  i18n: {
    ns: ['translation', 'datamaster-forms'],
    defaultNS: 'translation',
    locales: ['de', 'it', 'fr'],
    preload: ['de', 'it', 'fr'],
    whitelist: ['de', 'it', 'fr'],
    fallbackLng: false,
    saveMissing: false,
    nsSeparator: ':::',
    keySeparator: '::',
    detection: {
      order: ['htmlTag']
    },
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    },
    backend: {
      loadPath: '/static/locales/{{lng}}/{{ns}}.json',
      addPath: '/debug/locales/add/{{lng}}/{{ns}}'
    }
  }
}; // google map url with extracted vars (with temp Key)

var googleMapData = {
  url: 'https://maps.googleapis.com/maps/api/js',
  vars: {
    v: '3.exp',
    libraries: 'geometry,drawing,places',
    key: 'AIzaSyBgNUUV1lnVBlILWbDCDOb-F7jk_t05kl8'
  }
}; // googleMapData serialized to URL string

cfg.googleMapURL = googleMapData.url + '?' + Object.keys(googleMapData.vars).map(function (key) {
  return key + '=' + googleMapData.vars[key];
}).join('&');
var _default = cfg;
exports.default = _default;
var api = cfg.api,
    googleMapURL = cfg.googleMapURL;
exports.googleMapURL = googleMapURL;
exports.api = api;


//////////////////
// WEBPACK FOOTER
// ./client/conf.js
// module id = 9
// module chunks = 0